<template>
  <div>
    <v-container fluid class="pa-0 pb-8">
      <v-container class="container-custom">
        <Breadcrumbs
          :title="'Editar título'"
          :description="'Editar un título'"
        ></Breadcrumbs>
        <template>
          <v-row justify="center">
            <v-col class="viewSpaces" sm="12">
              <OutlinedCard :title="'Titulación'" class="mb-6">
                <v-row>
                  <v-col sm="3" class="py-2">
                    <v-text-field
                      :error-messages="
                        $v.code.$anyDirty && $v.code.$anyError
                          ? !$v.code.required
                            ? 'modules.departments.create.validation_errors.code'
                            : 'modules.departments.create.validation_errors.code_unique'
                          : ''
                      "
                      :loading="loadingCode"
                      v-model.trim="studentRecord"
                      :disabled="true"
                      :label="'Legajo *'"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col sm="3" class="py-2">
                    <v-select
                      outlined
                      :items="academicDegrees"
                      item-text="description"
                      item-value="id"
                      return-object
                      :label="`Título*`"
                      @change="onChangeTitle"
                      :disabled="true"
                      v-model="selectedDegree"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="6" class="py-2">
                    <v-text-field
                      v-model.trim="name"
                      :label="'Nombre *'"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col sm="3" class="py-2">
                    <v-text-field
                      v-model.trim="note"
                      :label="'Nota final *'"
                      outlined
                      @keypress="$validateDecimalInputNumber($event, note, 10)"
                      @blur="$v.note.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" class="py-2">
                    <v-textarea
                      outlined
                      :label="'Descripción *'"
                      @blur="$v.description.$touch()"
                      v-model="$v.description.$model"
                      :disabled="true"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="3" class="py-2">
                    <v-text-field
                      v-model.trim="regNote"
                      :label="'Nro reg *'"
                      outlined
                      v-mask="'####################'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </OutlinedCard>
              <div class="d-flex justify-end">
                <Button
                  white
                  :text="$t('actions.cancel')"
                  @clicked="$router.replace('/academic/titles')"
                  @end="resetButtonValues()"
                  class="mr-4"
                ></Button>
                <Button
                  :loading="createButton.loading"
                  :success="createButton.success"
                  :error="createButton.error"
                  :text="$t('actions.save')"
                  :successText="$t('actions.created')"
                  :errorText="'Error'"
                  :disabled="!canUpdate"
                  @end="resetButtonValues()"
                  @clicked="updateTitle"
                ></Button>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-container>
  </div>
</template>
 
<script>
import Breadcrumbs from'@/components/Breadcrumbs/Breadcrumbs';
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
import Button from '@/components/Button/Button';
import { $student, $degrees } from '../Services';
import { required, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';

export default {
  name: 'TitlesCreate',
  components: {
    Breadcrumbs,
    OutlinedCard,
    Button,
  },
  data() {
    return {
      studentTitleId: null,
      titles: [],
      paginationLimit: 100,
      loadingCode: false,
      codeUnique: null,
      createButton: {
        loading: false,
        success: false,
        error: false,
      },
      studentRecord: null,
      name: null,
      note: null,
      regNote: null,
      code: null,
      codeSt: null,
      description: null,
      selectedDegree: null,
      academicDegrees: [],
    };
  },
  validations: {
    name: {
      required,
      maxLength: maxLength(75),
    },
    academicDegrees: { required },
    code: {
      required,
      unique() {
        return this.codeUnique !== false;
      },
    },
    description: { required },
    studentRecord: { required },
    regNote: { required },
    note: { required, minValue: minValue(0), maxValue: maxValue(10) },
    formValid: [
      'name',
      'academicDegrees',
      'code',
      'description',
      'studentRecord',
      'regNote',
      'note',
    ],
  },
  computed: {
    canUpdate() {
      return this.name && this.note && this.regNote;
    },
  },
  methods: {
    async getTitlesByStudentTitleId(studentTitleId) {
      try {
        const titlesResponse = await $student.getTitlesByStTitleId(
          studentTitleId
        );
        this.titles = titlesResponse.data;
        this.studentRecord = this.titles.studentRecordId;
        this.name = this.titles.studentName;
        this.note = this.titles.grade;
        this.regNote = this.titles.registry;
        this.selectedDegree = this.academicDegrees.filter(
          (item) => this.titles.academicDegree.id == item.id
        );
        this.description = this.titles.academicDegree.degreeDescription;
      } catch {
        this.$store.dispatch('commons/openPopUp', {
          title: 'Error al obtener el título del estudiante',
          actionPrimary: {
            text: 'Aceptar',
            callback() {},
          },
          icon: { color: 'error', name: 'mdi-alert' },
          color: 'primary',
        });
      }
    },
    onChangeTitle(title) {
      this.$v.description.$model = title.description;
      this.selectedDegree = title.id;
    },
    async updateTitle() {
      this.createButton.loading = true;

      const currentDate = new Date();
      const formattedDate = currentDate.toISOString();

      const updateStudentTitle = {
        id: Number(this.studentTitleId),
        status: 1,
        statusDate: formattedDate,
        registry: this.regNote,
        studentName: this.name,
        grade: parseFloat(this.note),
        titleId: this.selectedDegree,
        url: null,
        studentRecordId: this.studentRecord,
        description: this.description,
      };

      const response = await $student.updateStudentTitle(updateStudentTitle);

      if (response.status == 200) {
        this.createButton.loading = false;
        this.$store.dispatch('commons/openPopUp', {
          title: 'Título editado con éxito',
          actionPrimary: {
            text: 'Aceptar',
            callback: () => {
              this.$router.go(-1);
            },
          },
          icon: { color: 'success', name: 'mdi-check' },
          color: 'primary',
        });
      } else {
        this.createButton.loading = false;
        this.$store.dispatch('commons/openPopUp', {
          title: 'Error al editar el título del estudiante',
          actionPrimary: {
            text: 'Aceptar',
            callback() {},
          },
          icon: { color: 'error', name: 'mdi-alert' },
          color: 'primary',
        });
      }
    },
    resetButtonValues() {
      this.createButton.loading = false;
      this.createButton.success = false;
      this.createButton.error = false;
    },
    async getAcademicDegrees() {
      const degrees = await $degrees.find(null, null, {
        params: { page: 0, length: 500 },
      });
      this.academicDegrees = degrees.data.content;
    },
  },
  watch: {
    'titles': function (val) {
      this.selectedDegree = val.academicDegree.id;
    },
  },
  mounted() {
    this.getAcademicDegrees();
    this.studentTitleId = this.$route.params.id;
    this.getTitlesByStudentTitleId(this.studentTitleId);
  },
};
</script>